import React from 'react';

// 공지사항 목록 스켈레톤 컴포넌트
export const NoticeListSkeleton: React.FC = () => {
    return (
        <main className="bg-gray-50 min-h-screen overflow-y-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                {/* 제목 스켈레톤 */}
                <div className="h-8 bg-gray-200 rounded-lg w-48 mb-6 animate-pulse"></div>
            </div>
            <div className="container mx-auto px-3 sm:px-4 lg:px-6 pt-4">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                    <div className="p-4">
                        <div className="space-y-3">
                            {[...Array(2)].map((_, index) => (
                                <div
                                    key={index}
                                    className="block bg-white border border-gray-200 rounded-lg p-3"
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex-1">
                                            <div className="flex items-center gap-2 mb-1">
                                                {/* 중요 배지 스켈레톤 (랜덤하게 표시) */}
                                                {index % 3 === 0 && (
                                                    <div className="h-5 bg-red-100 rounded-full w-12 animate-pulse"></div>
                                                )}
                                                {/* 제목 스켈레톤 */}
                                                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                                            </div>
                                            {/* 내용 스켈레톤 */}
                                            <div className="space-y-1 mb-2">
                                                <div className="h-3 bg-gray-200 rounded w-full animate-pulse"></div>
                                                <div className="h-3 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                                            </div>
                                            {/* 날짜 스켈레톤 */}
                                            <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                                        </div>
                                        <div className="ml-4">
                                            {/* 화살표 아이콘 스켈레톤 */}
                                            <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

// 공지사항 상세 스켈레톤 컴포넌트
export const NoticeDetailSkeleton: React.FC = () => {
    return (
        <main className="bg-gray-50 min-h-screen overflow-y-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                <div className="max-w-4xl mx-auto">
                    {/* 헤더 영역 스켈레톤 */}
                    <div className="mb-6">
                        {/* 뒤로가기 버튼 스켈레톤 */}
                        <div className="mb-6">
                            <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                        </div>

                        {/* 제목 영역 스켈레톤 */}
                        <div className="flex items-center gap-3 mb-4">
                            {/* 중요 배지 스켈레톤 */}
                            <div className="h-6 bg-red-100 rounded-full w-16 animate-pulse"></div>
                            {/* 제목 스켈레톤 */}
                            <div className="h-8 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                        </div>

                        {/* 작성일시 스켈레톤 */}
                        <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                    </div>

                    {/* 공지사항 상세 스켈레톤 */}
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                        {/* 내용 스켈레톤 */}
                        <div className="px-6 py-8">
                            <div className="space-y-3">
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-4/5 animate-pulse"></div>
                                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                            </div>
                        </div>

                        {/* 첨부 이미지 스켈레톤 */}
                        <div className="px-6 py-4 border-t border-gray-200">
                            <div className="h-4 bg-gray-200 rounded w-20 mb-3 animate-pulse"></div>
                            <div className="flex justify-center">
                                {/* 모바일/태블릿용 이미지 스켈레톤 */}
                                <div className="w-full max-w-sm h-48 bg-gray-200 rounded-lg animate-pulse lg:hidden"></div>
                                {/* PC용 이미지 스켈레톤 */}
                                <div className="w-full max-w-md h-48 bg-gray-200 rounded-lg animate-pulse hidden lg:block"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

// 무한 스크롤 로딩 스켈레톤
export const NoticeListLoadingSkeleton: React.FC = () => {
    return (
        <div className="space-y-3">
            {[...Array(3)].map((_, index) => (
                <div
                    key={index}
                    className="block bg-white border border-gray-200 rounded-lg p-3"
                >
                    <div className="flex items-start justify-between">
                        <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                                {index % 2 === 0 && (
                                    <div className="h-5 bg-red-100 rounded-full w-12 animate-pulse"></div>
                                )}
                                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                            </div>
                            <div className="space-y-1 mb-2">
                                <div className="h-3 bg-gray-200 rounded w-full animate-pulse"></div>
                                <div className="h-3 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                            </div>
                            <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                        </div>
                        <div className="ml-4">
                            <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
